import { useDispatch, useSelector } from 'react-redux';
import { Checkbox } from '@pmi/dsm-react';
import { User } from '../../../../../../shared/models/UserModels';
import {
  addUsers,
  adminUsersLayoutSelector,
  removeUsers,
} from '../../adminUsersLayoutSlice';
import { TableCellProps } from '../models';
import styles from './RowSelectionHeader.module.scss';
import CustomMinusIcon from '../../../../../../shared/components/CustomMinusIcon';

export default function RowSelectionHeader({ users }: { users: User[] }) {
  const dispatch = useDispatch();
  const { selectedRows } = useSelector(adminUsersLayoutSelector);
  const selectedUserIds = selectedRows.map((e) => e.id);
  const currentPageSelectedUsersCount = users.filter((user) =>
    selectedUserIds.includes(user.id),
  ).length;
  const checked =
    currentPageSelectedUsersCount === users.length &&
    currentPageSelectedUsersCount > 0;

  const handleChange = (isChecked: boolean) => {
    if (isChecked)
      dispatch(
        addUsers(users.filter((user) => !selectedUserIds.includes(user.id))),
      );
    else dispatch(removeUsers(users.map((e) => e.id)));
  };

  const props: any = {
    indeterminate: !checked && currentPageSelectedUsersCount > 0,
    indeterminateIcon: <CustomMinusIcon />,
  };

  return (
    <div className={styles.selectAllCheckBox}>
      <Checkbox
        name="selectAll"
        checked={checked}
        {...props} // eslint-disable-line
        onChange={(e, isChecked) => handleChange(isChecked)}
      />
    </div>
  );
}

export function RowSelectionCell({ row }: TableCellProps) {
  const dispatch = useDispatch();
  const { selectedRows } = useSelector(adminUsersLayoutSelector);
  const selectedUserIds = selectedRows.map((e) => e.id);

  const checked = selectedUserIds.includes(row.original?.id);

  const handleChange = (isChecked: boolean) => {
    if (isChecked) dispatch(addUsers([row.original]));
    else dispatch(removeUsers([row.original?.id]));
  };

  return (
    <div className="mt-1 ps-1">
      <Checkbox
        checked={checked}
        name="row-selection"
        onChange={(e, isChecked) => handleChange(isChecked)}
      />
    </div>
  );
}
